// extracted by mini-css-extract-plugin
export default {"button":"ToggleButton_button__TiXQd","small":"ToggleButton_small__JWWT9","large":"ToggleButton_large__e7F+C","img":"ToggleButton_img__8rIkC"};